<template>
    <section class="flexContainer fd-c full">
        <div class="container">
            <!-- <div> -->
            <!-- <router-link to="/admin-tools">Retour à l'administration</router-link> -->
            <!-- </div> -->
            <div class="flexContainer uploader fd-c">
                <h2 class="uploader-title">{{ $t("import.action") }}</h2>

                <div class="uploader-form" v-if="loading === false">
                    <form enctype="multipart/form-data" :action="actionUrl" novalidate v-on:submit.prevent>
                        <span class="bold">{{ $t("import.type") }}: </span>
                        <select v-model="selected">
                            <option disabled value="">{{ $t("import.choose") }}</option>
                            <option value="module">{{ $t("import.module") }}</option>
                            <option value="product">{{ $t("import.product") }}</option>
                            <option value="accessory">{{ $t("import.accessory") }}</option>
                        </select>
                        <div class="uploader-form-input mt10">
                            <input
                                type="file"
                                :name="uploadFieldName"
                                @change="
                                    onSubmit($event.target);
                                    fileCount = $event.target.files.length;
                                "
                                accept=".xlsx, .xls"
                            />
                        </div>
                    </form>
                </div>

                <div class="spinner spinner--overlay" v-if="loading === true">
                    <Spinner :animation-duration="2500" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import httpService from "../../components/service";
import "whatwg-fetch";
import Globals from "../globals.js";
import Spinner from "vue-simple-spinner";

export default {
    components: {
        Spinner
    },
    data() {
        const urlUpload = `/admin/import-components`;
        return {
            actionUrl: urlUpload,
            uploadFieldName: "file",
            loading: false,
            selected: "",
            componentType: ""
        };
    },
    methods: {
        upload(formData) {
            this.loading = true;
            let prom = httpService.upload(this.actionUrl, formData);

            prom.then(resp => {
                this.loading = false;

                if (resp.code && resp.code === 400) {
                    // exception back always return 400
                    alert(resp.message);
                    this.resetInput();
                } else if (resp.success === false) {
                    // import has error
                    this.$swal({
                        text: this.$t("modalImportFile.errorImportTxt"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "red",
                        confirmButtonText: this.$t("modalImportFile.errorImportConfirmBtnTxt"),
                        cancelButtonText: this.$t("modalImportFile.errorImportCancelBtnTxt")
                    })
                        .then(result => {
                            if (result === true) {
                                window.open(Globals.getBaseUrl() + resp.log_file);
                            }
                        })
                        .catch(() => {
                            // try again reset input file
                            this.resetInput();
                        });
                } else if (resp.success === true) {
                    // import success
                    if (this.selected === "module") {
                        this.componentType = this.$t("import.modules");
                    } else if (this.selected === "product") {
                        this.componentType = this.$t("import.products");
                    } else if (this.selected === "accessory") {
                        this.componentType = this.$t("import.accessories");
                    }
                    this.$swal({
                        html: this.$t("modalImportFile.successImportTxt", { count: resp.response.count, componentType: this.componentType }),
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: "green",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: this.$t("modalImportFile.successImportConfirmBtnTxt")
                    }).then(result => {
                        if (result === true) {
                            this.$router.push("/catalog");
                        }
                    });
                }

                this.resetInput();
            });
        },
        onSubmit(elt) {
            const formData = new FormData();
            formData.append("file", elt.files[0]);
            formData.append("type", this.selected);
            this.upload(formData);
        },
        resetInput() {
            this.$input.value = "";
        }
    },
    mounted() {
        // save ref to input to reset after send file
        this.$input = this.$el.querySelector('input[type="file"]');
    }
};
</script>

<style scoped lang="scss">
.uploader {
    background: #e8e8e8;
    padding: 1rem;
    overflow: hidden;

    &-title {
        background: #e8e8e8;
    }
    &-form {
        background: transparent;

        &-input {
            background: transparent;
        }
    }
}

.spinner {
    z-index: 10;
    width: 100%;

    &--overlay {
    }

    .loader {
        padding: 2rem;
        width: 100%;
        background: rgba(204, 200, 200, 0.39);
    }
}
</style>



// WEBPACK FOOTER //
// uploader.vue?0e3fcf7a